export default "__VITE_ASSET__D6C1v$_G__"